(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description-readmore"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-readmore-toggle]');
    if (!btn) return;
    const wrap = btn.closest('[data-collection-readmore]');
    if (!wrap) return;
    const full = wrap.querySelector('.collection-description-readmore__full');
    const excerpt = wrap.querySelector('.collection-description-readmore__excerpt');
    const more = btn.getAttribute('data-label-more') || 'Read more';
    const less = btn.getAttribute('data-label-less') || 'Read less';
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      full.hidden = true;
      excerpt.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = more;
    } else {
      full.hidden = false;
      excerpt.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = less;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /**
   * With `grid-column: span 2`, a 3-column grid after 8 products leaves one cell on the row
   * (P7, P8, [hole]); the promo cannot fit two columns there and auto-placement leaves a gap.
   * Compute how many columns are free on that row and use span 1 when only one slot remains.
   */
  const PROMO_MEDIA = '(min-width: 750px)';

  function countProductGridColumns(grid) {
    const tmpl = getComputedStyle(grid).gridTemplateColumns;
    if (!tmpl || tmpl === 'none') {
      return 0;
    }

    const parts = tmpl.trim().split(/\s+/).filter(Boolean);
    if (parts.length > 1) {
      return parts.length;
    }

    if (parts[0].includes('repeat')) {
      const w = grid.clientWidth;
      if (w < 1) {
        return 0;
      }

      const gapStr = getComputedStyle(grid).columnGap || getComputedStyle(grid).gap || '0';
      const gap = Number.parseFloat(gapStr) || 0;
      const minMatch = tmpl.match(/minmax\(\s*([^,)]+)/i);
      let minPx = 250;
      if (minMatch) {
        const v = minMatch[1].trim();
        if (v.endsWith('px')) {
          minPx = Number.parseFloat(v) || minPx;
        }
      }

      return Math.max(1, Math.floor((w + gap) / (minPx + gap)));
    }

    return parts.length;
  }

  function syncCollectionPromoGridSpan() {
    const promo = document.querySelector('.product-grid__item--promo');
    const grid = promo?.closest('.product-grid');

    if (!promo || !grid) {
      return;
    }

    const mq = window.matchMedia(PROMO_MEDIA);
    if (!mq.matches) {
      promo.removeAttribute('data-promo-span');
      return;
    }

    const after = Number.parseInt(promo.dataset.promoAfter || '8', 10);
    const cols = countProductGridColumns(grid);
    if (!cols) {
      return;
    }

    const r = after % cols;
    const spaceLeft = r === 0 ? cols : cols - r;
    const span = Math.min(2, spaceLeft);

    promo.dataset.promoSpan = String(span);
  }

  function initCollectionPromoGridSpan() {
    const grid = document.querySelector('.product-grid');
    const promo = document.querySelector('.product-grid__item--promo');

    if (!grid || !promo) {
      return;
    }

    const run = () => {
      window.requestAnimationFrame(syncCollectionPromoGridSpan);
    };

    run();

    const ro = new ResizeObserver(run);
    ro.observe(grid);

    const mq = window.matchMedia(PROMO_MEDIA);
    mq.addEventListener('change', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionPromoGridSpan, { once: true });
  } else {
    initCollectionPromoGridSpan();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-ettc-blog"] && !Shopify.designMode) return;
  try {
    
  const INITIAL_VISIBLE = 9;
  const LOAD_MORE_COUNT = 12;
  const FIRST_POSTS_COUNT = 3;

  class EttcBlogController {
    constructor(section) {
      this.section = section;
      this.restGrid = section.querySelector('[data-ettc-blog-grid]');
      this.firstGrid = section.querySelector('.ettc-blog__posts-grid--first');
      this.loadMoreWrap = section.querySelector('[data-ettc-load-more]');
      this.loadMoreBtn = this.loadMoreWrap?.querySelector('.ettc-blog__load-more-btn');
      this.viewingCount = section.querySelector('[data-ettc-viewing-count]');
      this.searchRow = section.querySelector('[data-ettc-search-row]');
      this.searchInput = this.searchRow?.querySelector('[data-ettc-search-input]');

      this.firstItems = this.firstGrid
        ? [...this.firstGrid.querySelectorAll('.ettc-blog__post-item')]
        : [];
      this.restItems = this.restGrid
        ? [...this.restGrid.querySelectorAll('.ettc-blog__post-item')]
        : [];
      this.allItems = [...this.firstItems, ...this.restItems];
      this.filteredRestItems = [...this.restItems];
      this.visibleRestCount = INITIAL_VISIBLE;

      if (this.allItems.length === 0) return;

      this.#hideExcess();
      this.#bindLoadMore();
      this.#bindSearchToggle();
      this.#bindSearchInput();
      this.#bindDrawer();
    }

    #hideExcess() {
      this.filteredRestItems.forEach((item, i) => {
        item.style.display = i < this.visibleRestCount ? '' : 'none';
      });
      this.#updateLoadMoreVisibility();
      this.#updateViewingCount();
    }

    #updateLoadMoreVisibility() {
      if (!this.loadMoreWrap) return;
      this.loadMoreWrap.style.display =
        this.visibleRestCount >= this.filteredRestItems.length ? 'none' : '';
    }

    #updateViewingCount() {
      if (!this.viewingCount) return;
      const visibleFirst = this.firstItems.filter(
        (el) => el.style.display !== 'none'
      ).length;
      const visibleRest = Math.min(
        this.visibleRestCount,
        this.filteredRestItems.length
      );
      const shown = visibleFirst + visibleRest;
      const total = this.firstItems.length + this.filteredRestItems.length;
      this.viewingCount.textContent = `Viewing 1 - ${shown} of ${total} articles`;
    }

    #bindLoadMore() {
      this.loadMoreBtn?.addEventListener('click', () => {
        this.visibleRestCount += LOAD_MORE_COUNT;
        this.#hideExcess();
      });
    }

    #bindSearchToggle() {
      const toggleBtns = this.section.querySelectorAll('[data-ettc-search-toggle]');
      const closeBtn = this.searchRow?.querySelector('[data-ettc-search-close]');

      const open = () => {
        if (!this.searchRow) return;
        this.searchRow.hidden = false;
        toggleBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
        this.searchInput?.focus();
      };

      const close = () => {
        if (!this.searchRow) return;
        this.searchRow.hidden = true;
        toggleBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        if (this.searchInput) {
          this.searchInput.value = '';
          this.#filterBySearch();
        }
      };

      toggleBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const isOpen = !this.searchRow?.hidden;
          if (isOpen) close();
          else open();
        });
      });

      closeBtn?.addEventListener('click', close);
    }

    #bindSearchInput() {
      if (!this.searchInput) return;

      let debounceTimer;
      this.searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => this.#filterBySearch(), 200);
      });
    }

    #filterBySearch() {
      const query = (this.searchInput?.value || '').trim().toLowerCase();
      const matchItem = (item) => {
        const title = item.dataset.ettcBlogTitle || '';
        const tags = item.dataset.ettcBlogTags || '';
        return title.includes(query) || tags.includes(query);
      };

      this.firstItems.forEach((item) => {
        item.style.display =
          !query || matchItem(item) ? '' : 'none';
      });

      if (!query) {
        this.filteredRestItems = [...this.restItems];
      } else {
        this.filteredRestItems = this.restItems.filter(matchItem);
      }

      this.restItems.forEach((item) => {
        item.style.display = 'none';
      });

      this.visibleRestCount = INITIAL_VISIBLE;
      this.filteredRestItems.forEach((item, i) => {
        item.style.display = i < this.visibleRestCount ? '' : 'none';
      });

      this.#updateLoadMoreVisibility();
      this.#updateViewingCount();
    }

    #bindDrawer() {
      const menuBtn = this.section.querySelector('.ettc-blog__mobile-menu-btn');
      const drawer = this.section.querySelector('.ettc-blog__drawer');
      if (!menuBtn || !drawer) return;

      const closeBtn = drawer.querySelector('.ettc-blog__drawer-close');
      const overlay = drawer.querySelector('.ettc-blog__drawer-overlay');

      const open = () => {
        drawer.classList.add('ettc-blog__drawer--open');
        drawer.setAttribute('aria-hidden', 'false');
        menuBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        closeBtn?.focus();
      };

      const close = () => {
        drawer.classList.remove('ettc-blog__drawer--open');
        drawer.setAttribute('aria-hidden', 'true');
        menuBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        menuBtn.focus();
      };

      menuBtn.addEventListener('click', open);
      closeBtn?.addEventListener('click', close);
      overlay?.addEventListener('click', close);

      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
    }
  }

  document.querySelectorAll('.ettc-blog').forEach((section) => {
    new EttcBlogController(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const playButton = event.target.closest('[data-product-video-gallery-play]');
    if (!playButton) return;

    const media = playButton.closest('.product-video-gallery__media');
    if (!media) return;

    const video = media.querySelector('video');
    if (!video) return;

    video.controls = true;
    media.classList.add('product-video-gallery__media--playing');
    video.play();
  });

  } catch(e) { console.error(e); }
})();
})();
